(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-detail-script"] && !Shopify.designMode) return;
  try {
    (function () {
  function productDetailSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-product-detail]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-product-detail]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initProductDetail(root) {
    productDetailSections(root).forEach(function (section) {
      if (section.dataset.productDetailInitialized === 'true') return;
      section.dataset.productDetailInitialized = 'true';

      section.querySelectorAll('.product-detail-content__description img:not([alt])').forEach(function (image) {
        image.setAttribute('alt', '');
      });

      var galleryTrack = section.querySelector('[data-gallery-track]');
      var gallerySlides = section.querySelectorAll('[data-gallery-slide]');
      var galleryCounter = section.querySelector('[data-gallery-counter]');
      var galleryViewport = section.querySelector('[data-gallery-viewport]');
      var gallery = section.querySelector('[data-product-gallery]');
      var galleryIndex = 0;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragCurrentX = 0;
      var isDragging = false;
      var galleryDragActive = false;
      var activePointerId = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var galleryAutoplayEnabled = gallery && gallery.dataset.galleryAutoplay === 'true';
      var galleryAutoplayDelay = gallery ? parseInt(gallery.dataset.galleryAutoplayDelay, 10) : 0;
      var galleryAutoplayTimer = null;

      if (!galleryAutoplayDelay || galleryAutoplayDelay < 1000) {
        galleryAutoplayDelay = 5000;
      }

      function translateGallery(deltaX) {
        if (!galleryTrack) return;

        if (deltaX) {
          galleryTrack.style.transform = 'translateX(calc(' + (-100 * galleryIndex) + '% + ' + deltaX + 'px))';
          return;
        }

        galleryTrack.style.transform = 'translateX(' + (-100 * galleryIndex) + '%)';
      }

      function setGallery(index) {
        if (!galleryTrack || gallerySlides.length < 2) return;
        galleryIndex = (index + gallerySlides.length) % gallerySlides.length;
        translateGallery(0);
        if (galleryCounter) {
          galleryCounter.textContent = (galleryIndex + 1) + ' / ' + gallerySlides.length;
        }
      }

      function mediaIndexForVariant(variant) {
        if (!variant || !gallerySlides.length) return -1;

        var mediaId = variant.featured_media && variant.featured_media.id;
        var imageId = variant.featured_image && variant.featured_image.id;

        if (!mediaId && !imageId) return -1;

        for (var i = 0; i < gallerySlides.length; i++) {
          var slide = gallerySlides[i];

          if (mediaId && slide.getAttribute('data-gallery-media-id') === String(mediaId)) {
            return i;
          }

          if (imageId && slide.getAttribute('data-gallery-image-id') === String(imageId)) {
            return i;
          }
        }

        return -1;
      }

      function syncGalleryToVariant(variant) {
        var matchIndex = mediaIndexForVariant(variant);
        if (matchIndex > -1 && matchIndex !== galleryIndex) {
          setGallery(matchIndex);
          restartGalleryAutoplay();
        }
      }

      function startGalleryAutoplay() {
        if (!galleryAutoplayEnabled || reduceMotion || gallerySlides.length < 2 || galleryAutoplayTimer) return;

        galleryAutoplayTimer = window.setInterval(function () {
          if (isDragging || document.visibilityState === 'hidden') return;
          setGallery(galleryIndex + 1);
        }, galleryAutoplayDelay);
      }

      function stopGalleryAutoplay() {
        if (!galleryAutoplayTimer) return;
        window.clearInterval(galleryAutoplayTimer);
        galleryAutoplayTimer = null;
      }

      function restartGalleryAutoplay() {
        stopGalleryAutoplay();
        startGalleryAutoplay();
      }

      if (galleryViewport && gallerySlides.length > 1) {
        function beginGalleryDrag(clientX, clientY, pointerId) {
          stopGalleryAutoplay();
          activePointerId = pointerId;
          dragStartX = clientX;
          dragStartY = clientY;
          dragCurrentX = clientX;
          isDragging = true;
          galleryDragActive = false;
        }

        function activateGalleryDrag(event) {
          if (galleryDragActive) return;
          galleryDragActive = true;
          galleryViewport.classList.add('is-dragging');

          if (
            event &&
            event.pointerId !== undefined &&
            galleryViewport.setPointerCapture &&
            (!galleryViewport.hasPointerCapture || !galleryViewport.hasPointerCapture(event.pointerId))
          ) {
            galleryViewport.setPointerCapture(event.pointerId);
          }
        }

        function cancelGalleryDrag() {
          galleryViewport.classList.remove('is-dragging');
          isDragging = false;
          galleryDragActive = false;
          activePointerId = null;
          setGallery(galleryIndex);
          startGalleryAutoplay();
        }

        function moveGalleryDrag(clientX, clientY, event) {
          if (!isDragging) return;

          var deltaX = clientX - dragStartX;
          var deltaY = clientY - dragStartY;
          var absX = Math.abs(deltaX);
          var absY = Math.abs(deltaY);

          if (!galleryDragActive) {
            if (absY > absX && absY > 8) {
              cancelGalleryDrag();
              return;
            }

            if (absX <= 8) return;
            activateGalleryDrag(event);
          }

          if (event && event.cancelable) {
            event.preventDefault();
          }

          dragCurrentX = clientX;
          translateGallery(deltaX);
        }

        function endGalleryDrag(event) {
          if (!isDragging) return;
          if (event && event.pointerId !== undefined && event.pointerId !== activePointerId) return;

          var deltaX = dragCurrentX - dragStartX;
          var threshold = Math.max(34, Math.min(galleryViewport.clientWidth * 0.14, 64));
          var wasDragActive = galleryDragActive;

          if (
            event &&
            event.pointerId !== undefined &&
            galleryViewport.releasePointerCapture &&
            galleryViewport.hasPointerCapture &&
            galleryViewport.hasPointerCapture(event.pointerId)
          ) {
            galleryViewport.releasePointerCapture(event.pointerId);
          }

          galleryViewport.classList.remove('is-dragging');
          isDragging = false;
          galleryDragActive = false;
          activePointerId = null;

          if (wasDragActive && Math.abs(deltaX) > threshold) {
            setGallery(galleryIndex + (deltaX < 0 ? 1 : -1));
            startGalleryAutoplay();
            return;
          }

          setGallery(galleryIndex);
          startGalleryAutoplay();
        }

        galleryViewport.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'touch') return;
          if (event.button !== undefined && event.button !== 0) return;
          beginGalleryDrag(event.clientX, event.clientY, event.pointerId);
        });

        galleryViewport.addEventListener('pointermove', function (event) {
          if (!isDragging || event.pointerId !== activePointerId) return;
          moveGalleryDrag(event.clientX, event.clientY, event);
        });

        galleryViewport.addEventListener('pointerup', endGalleryDrag);
        galleryViewport.addEventListener('pointercancel', endGalleryDrag);
        galleryViewport.addEventListener('lostpointercapture', endGalleryDrag);
        galleryViewport.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
        galleryViewport.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setGallery(galleryIndex - 1);
            restartGalleryAutoplay();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            setGallery(galleryIndex + 1);
            restartGalleryAutoplay();
          }
        });

        galleryViewport.addEventListener('focusin', stopGalleryAutoplay);
        galleryViewport.addEventListener('focusout', startGalleryAutoplay);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          stopGalleryAutoplay();
          return;
        }

        startGalleryAutoplay();
      });

      startGalleryAutoplay();

      function activateProductTab(button) {
        var id = button.getAttribute('data-product-tab');

        section.querySelectorAll('[data-product-tab]').forEach(function (tab) {
          var isActive = tab === button;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-product-panel]').forEach(function (panel) {
          var isActive = panel.getAttribute('data-product-panel') === id;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      section.querySelectorAll('[data-product-tab]').forEach(function (button) {
        button.addEventListener('click', function () {
          activateProductTab(button);
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-product-tab]'));
          var currentIndex = tabs.indexOf(button);
          var nextIndex = event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;

          event.preventDefault();
          if (nextIndex < 0) nextIndex = tabs.length - 1;
          if (nextIndex >= tabs.length) nextIndex = 0;
          tabs[nextIndex].focus();
          activateProductTab(tabs[nextIndex]);
        });
      });

      var addonToggle = section.querySelector('[data-addon-toggle]');
      if (addonToggle) {
        addonToggle.addEventListener('click', function () {
          var addons = addonToggle.closest('.product-addons');
          var expanded = addonToggle.getAttribute('aria-expanded') === 'true';
          addonToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (addons) addons.classList.toggle('is-collapsed', expanded);
        });
      }

      var variantsEl = section.querySelector('[data-product-variants]');
      var form = section.querySelector('[data-product-form]');
      if (!variantsEl || !form) return;

      var variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (error) {
        variants = [];
      }

      var variantInput = form.querySelector('[data-variant-id]');
      var optionInputs = form.querySelectorAll('[data-option-value]');
      var addonSelects = form.querySelectorAll('[data-addon-select]');
      var submitButtons = form.querySelectorAll('button[name="add"], [data-buy-now]');
      var buyNowButton = form.querySelector('[data-buy-now]');
      var formMessage = form.querySelector('[data-product-form-message]');
      var totalWrap = form.querySelector('[data-product-total-wrap]');
      var totalEl = form.querySelector('[data-product-total]');
      var cartSuccessUrl = form.getAttribute('data-cart-success-url') || '/cart';
      var cartErrorMessage = form.getAttribute('data-cart-error-message') || '';

      function selectedOptions() {
        var values = [];
        form.querySelectorAll('[data-option-index]').forEach(function (row) {
          var checked = row.querySelector('[data-option-value]:checked');
          values[parseInt(row.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
        });
        return values;
      }

      function variantMatchesValues(variant, values) {
        return variant.options.every(function (option, index) {
          return values[index] === null || values[index] === undefined || option === values[index];
        });
      }

      function optionValueHasAvailableVariant(optionIndex, optionValue, selectedValues) {
        var values = selectedValues.slice();
        values[optionIndex] = optionValue;

        return variants.some(function (variant) {
          return variant.available && variantMatchesValues(variant, values);
        });
      }

      function updateOptionAvailability(selectedValues) {
        form.querySelectorAll('[data-option-index]').forEach(function (row) {
          var optionIndex = parseInt(row.getAttribute('data-option-index'), 10);

          row.querySelectorAll('[data-option-value]').forEach(function (input) {
            var hasAvailableVariant = optionValueHasAvailableVariant(optionIndex, input.value, selectedValues);
            var label = input.nextElementSibling;

            input.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
            if (hasAvailableVariant) {
              input.removeAttribute('data-option-unavailable');
            } else {
              input.setAttribute('data-option-unavailable', 'true');
            }

            if (label) {
              label.classList.toggle('is-unavailable', !hasAvailableVariant);
            }
          });
        });
      }

      function formatMoney(cents) {
        var currency = totalWrap ? totalWrap.getAttribute('data-money-currency') : '';
        var locale = totalWrap ? totalWrap.getAttribute('data-money-locale') : document.documentElement.lang;
        var value = (Number(cents) || 0) / 100;
        var fractionDigits = currency === 'KRW' || currency === 'JPY' ? 0 : 2;

        try {
          return new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency: currency || 'KRW',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
          }).format(value);
        } catch (error) {
          return value.toLocaleString() + (currency ? ' ' + currency : '');
        }
      }

      function selectedAddonItems() {
        var items = [];

        addonSelects.forEach(function (select) {
          if (!select.value) return;

          var option = select.options[select.selectedIndex];
          items.push({
            id: Number(select.value),
            quantity: 1,
            price: Number(option.getAttribute('data-addon-price')) || 0,
          });
        });

        return items;
      }

      function updateTotal(variant, canSubmit) {
        if (!totalEl) return;

        var addonItems = selectedAddonItems();
        var itemCount = canSubmit ? 1 : 0;
        var total = canSubmit ? Number(variant.price) || 0 : 0;
        var countTemplate = totalWrap ? totalWrap.getAttribute('data-total-count-template') : '__count__';

        if (canSubmit) {
          addonItems.forEach(function (item) {
            itemCount += item.quantity;
            total += item.price * item.quantity;
          });
        }

        totalEl.textContent = formatMoney(total) + ' (' + countTemplate.replace('__count__', itemCount) + ')';
      }

      function buildCartItems(variant) {
        var items = [{ id: Number(variant.id), quantity: 1 }];

        selectedAddonItems().forEach(function (item) {
          items.push({ id: item.id, quantity: item.quantity });
        });

        return items;
      }

      function updateVariant() {
        var variant = variants[0];

        if (optionInputs.length) {
          var values = selectedOptions();
          updateOptionAvailability(values);
          variant = variants.find(function (item) {
            return variantMatchesValues(item, values);
          });
        }

        if (variantInput && variant) {
          variantInput.value = variant.id;
        }

        if (variant) {
          syncGalleryToVariant(variant);
        }

        var canSubmit = Boolean(variant && variant.available);
        submitButtons.forEach(function (button) {
          button.disabled = !canSubmit;
          button.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
        });

        if (formMessage) {
          formMessage.hidden = canSubmit;
        }

        updateTotal(variant, canSubmit);

        return variant;
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });

      addonSelects.forEach(function (select) {
        select.addEventListener('change', updateVariant);
      });

      updateVariant();

      if (buyNowButton) {
        buyNowButton.addEventListener('click', function () {
          var variant = updateVariant();
          if (!variant || !variant.available) return;

          var cartPermalinkBase = form.getAttribute('data-cart-permalink-base') || '/cart/';
          var permalinkItems = buildCartItems(variant).map(function (item) {
            return item.id + ':' + item.quantity;
          });

          window.location.href = cartPermalinkBase + permalinkItems.join(',') + '?checkout';
        });
      }

      form.addEventListener('submit', function (event) {
        var variant = updateVariant();
        if (!variant || !variant.available) {
          event.preventDefault();
          return;
        }

        if (!selectedAddonItems().length) return;

        event.preventDefault();
        if (form.getAttribute('data-submitting') === 'true') return;

        form.setAttribute('data-submitting', 'true');
        submitButtons.forEach(function (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        });

        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: buildCartItems(variant) }),
        })
          .then(function (response) {
            if (response.ok) return response.json();

            return response.json().then(function (error) {
              throw error;
            });
          })
          .then(function () {
            window.location.href = cartSuccessUrl;
          })
          .catch(function (error) {
            form.removeAttribute('data-submitting');
            updateVariant();

            if (formMessage) {
              formMessage.textContent = error.description || error.message || cartErrorMessage;
              formMessage.hidden = false;
            }
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDetail);
  } else {
    initProductDetail();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductDetail(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
